import { render } from "./PaymentProcedure.vue?vue&type=template&id=8ee41040&scoped=true"
import script from "./PaymentProcedure.vue?vue&type=script&lang=js"
export * from "./PaymentProcedure.vue?vue&type=script&lang=js"

import "./PaymentProcedure.vue?vue&type=style&index=0&id=8ee41040&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee41040"]])

export default __exports__